var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"logo-area"},[(!_vm.$HUDONGFENG)?_c('div',{staticClass:"dec"},[_vm._v("好大夫互联网医院平台")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }